module.exports = __webpack_public_path__ + "img/central_bank.dab4e11f.svg";